"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserThreads = getUserThreads;
var _common = require("./common");
function getUserThreads(date, page, domain, apiKey, token) {
  var url = "".concat(domain).concat(apiKey);
  var params = '';
  if (!date) {
    params = 'limit=50&minLimit=30';
  }
  if (date) {
    if (typeof date !== 'number') {
      date = Date.parse(date);
    }
    params = "time=".concat(date);
  }
  if (page) {
    params = params ? "".concat(params, "&page=").concat(page) : "page=".concat(page);
  }
  if (params) {
    url = "".concat(url, "?").concat(params);
  }
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token,
      'x-accept-version': 3
    },
    credentials: 'include'
  };
  return (0, _common.request)(url, options);
}